// This is the root (non React) TypeScript file for company/users;
const addUserButton = document.querySelector(
  '#manage-users a[href="/company/users/new"]'
);
if (!!addUserButton) {
  addUserButton.addEventListener("click", () => {
    window.amplitude.track("Add single user");
  });
}
const clipboardButton = document.getElementById("clipboard-button");

if (!!clipboardButton) {
  clipboardButton.addEventListener("click", () => {
    window.amplitude.track("Copy Link for Sharing Invite");
  });
}

const addBulkUsersButton = document.querySelector(
  '[href="/company/users/bulk_new"]'
);

if (!!addBulkUsersButton) {
  addBulkUsersButton.addEventListener("click", () => {
    window.amplitude.track("Bulk upload users");
  });
}
